import React from 'react'

const PurchasedItemCard = ({ name, imageUrl, issued, disabled, onToggle }) => {
	const handleClick = () => {
		if (!disabled) onToggle()
	}

	return (
		<div
			onClick={handleClick}
			style={{
				cursor: disabled ? 'default' : 'pointer',
				border: issued ? '3px solid #4caf50' : '3px solid transparent',
				borderRadius: '8px',
				padding: '1rem',
				textAlign: 'center',
				backgroundColor: '#f9f9f9',
				boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
				opacity: disabled ? 0.5 : 1,
				transition: 'all 0.2s ease-in-out',
				position: 'relative',
			}}
		>
			<h5 style={{ marginBottom: '0.75rem' }}>{name}</h5>

			{imageUrl ? (
				<img
					src={imageUrl}
					alt={name}
					style={{
						width: '100%',
						maxHeight: '100px',
						objectFit: 'contain',
						borderRadius: '6px',
						marginBottom: '0.5rem',
					}}
				/>
			) : (
				<div
					style={{
						height: '100px',
						backgroundColor: '#ddd',
						borderRadius: '6px',
						marginBottom: '0.5rem',
					}}
				/>
			)}

			<div
				style={{
					position: 'absolute',
					top: '10px',
					right: '10px',
					width: '24px',
					height: '24px',
					borderRadius: '50%',
					border: '2px solid #789',
					backgroundColor: issued ? '#4caf50' : 'transparent',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					fontSize: '16px',
					color: '#fff',
				}}
			>
				{issued ? '✓' : ''}
			</div>
		</div>
	)
}

export default PurchasedItemCard
